<span>{{ formatted_price }}</span>
